<template>
  <div>
    <template>
      <mdb-container>
        <mdb-modal
          :show="confirmar"
          @close="confirmar = false"
          size="sm"
          class="text-center"
          style="top:40px;"
          danger
        >
          <mdb-modal-header center :close="false">
            <p class="heading">Confirmar que quieres eliminar el partner {{partnerSelected.name}}</p>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-icon icon="times" size="4x" class="animated rotateIn" />
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
            <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-container>
    </template>

    <b-card>
      <modals-container v-model="items" />
      <template>
        <mdb-modal :show="modalCreate" @close="modalCreate = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{ modalName}}</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">


            <modal-create-partner 
            :onClick="closeModalCreate" 
            :modalStrategy="()=>openModalStrategy()"
            v-if="modalName=='Crear Partner'"
            ></modal-create-partner>

            <modal-edit-partner
            :onClick="closeModalCreate" 
            :partner="partnerSelected"
            :modalStrategy="()=>openModalStrategy()"
            v-if="modalName=='Editar Partner'"
          ></modal-edit-partner>


          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modalCreate = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>

      <template class="test">
      <mdb-modal  class="test-2"  :show="modalStrategy" @close="modalStrategy = false" fullHeight info removeBackdrop>
        <mdb-modal-header center :close="false">
          <p class="heading lead">Crear estrategia</p>
        </mdb-modal-header>
        <mdb-modal-body class="modal-body">
          <modal-create-strategy-action
            :onClick="closeModalCreateStrategy"
          ></modal-create-strategy-action>
        </mdb-modal-body>
        <mdb-modal-footer center>
          <mdb-btn outline="danger" @click="modalStrategy = false">Cancelar</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </template>


      <b-btn variant="primary" class="p-2 mb-4" @click="createPartner()">
        <i class="far fa-edit mr-1"></i>
        Nuevo Partner
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <div slot="country" slot-scope="data">
              <div>{{data.item.country_id.name?data.item.country_id.name:"No asociado"}}</div>
             
            </div>
        <template slot="phone" slot-scope="data">
          
            <div >
                {{data.item.phone?data.item.phone:"No asociado"}}
            </div>
        </template>

        <template slot="acciones" slot-scope="data">
          <b-row>
            <div class="seleccionar col-3">
              <b-badge variant="primary" class="p-2" @click="selectPartnerEdit(data.item,items)">
                <i class="far fa-edit mr-1"></i>Editar
              </b-badge>
            </div>
            <div class="seleccionar col-2">
              <b-badge variant="danger" class="p-2" @click="selectPartnerDelete(data.item)">
                <i class="far fa-trash-alt mr-1"></i>Eliminar
              </b-badge>
            </div>
          </b-row>
        </template>

        <!--<template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
        </template>-->
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import ModalCreatePartner from "../notifications/ModalCreatePartner";
import ModalEditPartner from "../notifications/ModalEditPartner";
import ModalCreateStrategyAction from "../notifications/ModalCreateStrategyAction";
import store from "../../store";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";
export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    ModalCreatePartner,
    ModalCreateStrategyAction,
    ModalEditPartner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      modalStrategy:false,
      partnerSelected: {},
      modalName: "",
      confirmar: false
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  mounted(){
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    closeModalCreate() {
      this.modalCreate = false;
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    createPartner() {
      this.modalName = "Crear Partner";
      this.modalCreate = true;
    },
    selectPartnerEdit(item, items) {
      this.partnerSelected = item;
      this.modalName = "Editar Partner";
      this.modalCreate = true;
    },
    selectPartnerDelete(item) {
      
      this.partnerSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    closeModalCreateStrategy() {
      this.modalStrategy = false;
    },
    openModalStrategy(){
      this.modalStrategy = true;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deletePartner", this.partnerSelected.id);
      }, 400);
      store.dispatch("deletePartnerUtility", this.partnerSelected.id);
      this.confirmar = false;
    }
  }
};
</script>

<style >
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}

.test-2 .modal-dialog{
  transform: translate(-405px, 0px) !important;
}
</style>
